import React from "react";
import "./CardTag.css";

function CardTag({ tag }) {
  return <h6 className="tag">{tag}</h6>
}

export default CardTag;